import { IconCheck } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './ProjectsDealsMenuItem.scss';

interface IProjectsDealsMenuItemProps {
    to: string;
    imgSrc: string;
    name?: string | null;
    subtitle?: string | null;
    title?: string;
    testId?: string;
    imgAlt?: string;
    isActive?: boolean;
    onClick?: () => void;
}

const ProjectsDealsMenuItem = ({
    to,
    imgSrc,
    name,
    subtitle,
    title,
    testId,
    imgAlt = '',
    isActive = false,
    onClick,
}: IProjectsDealsMenuItemProps) => (
    <Link
        className={classNames(
            'ProjectsDealsMenuItem__item d-flex align-items-center p-2',
            { 'ProjectsDealsMenuItem__item--active': isActive },
        )}
        to={to}
        title={title}
        role="menuitem"
        onClick={onClick}
        data-testid={testId}
    >
        <img
            src={imgSrc}
            height="34px"
            width="34px"
            alt={imgAlt}
            className="rounded bg-dark"
        />

        <div className="px-2 flex-grow-1 ProjectsDealsMenuItem__text">
            <div className="text-dark text-truncate">{name}</div>
            {subtitle && (
                <div className="text-muted text-truncate">{subtitle}</div>
            )}
        </div>

        {isActive && (
            <NSIcon icon={IconCheck} className="ml-2 text-primary" />
        )}
    </Link>
);

export default ProjectsDealsMenuItem;
